import { createSlice } from '@reduxjs/toolkit';
import { ILoad, ILoadStatuses } from 'Shared/Types/load';
import {
  getLoad,
  getLoadList,
  setNextLoadStatus,
  setPrevLoadStatus,
} from './reducer';
import { RootState } from 'Redux/store';

interface ILoadState {
  transitStatuses: ILoadStatuses | null;
  current: ILoad | null;
  list: ILoad[];
  count: number;
  error?: string | null;
  loading: boolean;
}

const initialState: ILoadState = {
  transitStatuses: null,
  current: null,
  count: 0,
  list: [],
  error: null,
  loading: false,
};

const loadSlice = createSlice({
  name: 'load',
  initialState,
  reducers: {
    resetCurrentLoads: (state) => {
      state.current = null;
      state.list = [];
    },
    resetTransitStatuses: (state) => {
      state.transitStatuses = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getLoadList.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getLoadList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(getLoadList.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      const { count, results } = action.payload;
      state.count = count;
      state.list = results || [];
    });

    builder.addCase(getLoad.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getLoad.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(getLoad.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.current = action.payload;
    });

    builder.addCase(setNextLoadStatus.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(setNextLoadStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(setNextLoadStatus.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.transitStatuses = { ...state.transitStatuses, ...action.payload };
    });

    builder.addCase(setPrevLoadStatus.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(setPrevLoadStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(setPrevLoadStatus.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.transitStatuses = { ...state.transitStatuses, ...action.payload };
    });
  },
});

export const { resetCurrentLoads, resetTransitStatuses } = loadSlice.actions;

export const selectLoadLoading = (state: RootState) => state.load.loading;
export const selectLoadError = (state: RootState) => state.load.error;
export const selectLoadList = (state: RootState) => state.load.list;
export const selectLoadCount = (state: RootState) => state.bid.count;
export const selectCurrentLoad = (state: RootState) => state.load.current;
export const selectLoadTransitStatuses = (state: RootState) =>
  state.load.transitStatuses;

export default loadSlice;
